export default {"src":"/_next/static/media/lock-icon.de514f66.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};